import React from "react";
import { useParams } from "react-router-dom";


/**
 * Componente para mostrar el tercer nivel de Nuestro Trabajo. Para la visualización se envía como 
 * parámetro el id de la opción del portafolio que se desea mostrar y  se cargan la información desde
 *  el archivo .src/data/data.json -> "Briefcase"
 *
 * @component
 * @example
 * 
 * "Briefcase": [
    {
      "id": 1,
      "img": "/img/briefcase/Portafolio1.webp",
      "video": "/video/portafolio/video1.mp4",
      "alt": "Snackeros",
      "text": "Una plataforma digital creada para disfrutar de la comida sin reglas",
      "url": "/nuestrotrabajo/portafolio",
      "reto": "Invitar a los ecuatorianos a romper con lo establecido al momento de comer, creando contenido original no publicitario.",
      "insight": "Llevamos años condicionando la forma en que comemos; cocinamos los mismos platos y los consumimos de manera convencional.",
      "idea": "Creamos <b>“Snackeros”</b>, la primera plataforma transmedia donde rompimos las reglas culinarias, mostrando la forma más auténtica de disfrutar la comida.",
      "resultados": "Demostramos que generar contenido de valor puede superar los resultados de publicidad tradicional, logrando conectar con la audiencia de manera innovadora. <br><br> <b>Sobrepasamos la participación digital en un 115%</b>, aumentando el nivel de ventas significativamente. <b>Pasamos del top 10 al top 5 de marcas más preferidas</b> en la categoría de bebidas no alcohólicas.",
      "ejecucion": "",
      "text2": ""
    }
  ]
 */

export const Portafolio = (props) => {

    if(props.data)
    {
        let param = useParams();

        function getBriefcase(id) {
            return props.data.find(el => el.id === parseInt(id));
        }

        return (
            <div id="briefcase-detail" className="text-center">
                <div className="container-fluid padding-fluid">
                    <div className="col-md-8 col-md-offset-2 section-title">
                        &nbsp;
                    </div>
                    <div className="row">
                        <div className="col-md-8 col-md-offset-2">
                            <video
                                style={{ maxWidth: "100%", width: "800px", margin: "0 auto" }}
                                playsInline
                                loop
                                controls
                                alt={getBriefcase(param.id).alt}
                                src={getBriefcase(param.id).video}
                                autoPlay={true}
                            />
                        </div>
                        <div className="col-md-2"></div>
                        <div className="col-md-8 col-md-offset-2">
                            <div>
                                <p className="captionimg">{getBriefcase(param.id).text}</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            &nbsp;
                        </div>
                    </div>
                    {getBriefcase(param.id).reto ? 
                        <div className="row">
                            <hr className="hrGeneral"></hr>
                            <div className="col-md-12 visible-md visible-lg">&nbsp;</div>
                            <div className="col-md-12 visible-md visible-lg">&nbsp;</div>
                            <div className="col-md-12 text-left">
                                <div className="col-md-5 col-md-offset-1 col-xs-offset-0">
                                    <h3>RETO</h3>
                                </div>
                                <div className="col-md-4">
                                    <div className="text" dangerouslySetInnerHTML={{__html:getBriefcase(param.id).reto}}></div>
                                </div>
                            </div>
                            <div className="col-md-12">&nbsp;</div>
                        </div>
                    : ""}
                    {getBriefcase(param.id).insight ? 
                        <div className="row">
                            <hr className="hrGeneral"></hr>
                            <div className="col-md-12 visible-md visible-lg">&nbsp;</div>
                            <div className="col-md-12 visible-md visible-lg">&nbsp;</div>
                            <div className="col-md-12 text-left">
                                <div className="col-md-5 col-md-offset-1">
                                    <h3>INSIGHT</h3>
                                </div>
                                <div className="col-md-4">
                                    <div className="text" dangerouslySetInnerHTML={{__html:getBriefcase(param.id).insight}}></div>
                                </div>
                            </div>
                            <div className="col-md-12">&nbsp;</div>
                        </div>
                    : ""}
                    {getBriefcase(param.id).idea ? 
                        <div className="row">
                            <hr className="hrGeneral"></hr>
                            <div className="col-md-12 visible-md visible-lg">&nbsp;</div>
                            <div className="col-md-12 visible-md visible-lg">&nbsp;</div>
                            <div className="col-md-12 text-left">
                                <div className="col-md-5 col-md-offset-1">
                                    <h3>IDEA ESTRATÉGICA</h3>
                                </div>
                                <div className="col-md-4">
                                    <div className="text" dangerouslySetInnerHTML={{__html:getBriefcase(param.id).idea}}></div>
                                </div>
                            </div>
                            <div className="col-md-12">&nbsp;</div>
                        </div>
                    : ""}
                    {getBriefcase(param.id).ejecucion ? 
                        <div className="row">
                            <hr className="hrGeneral"></hr>
                            <div className="col-md-12 visible-md visible-lg">&nbsp;</div>
                            <div className="col-md-12 visible-md visible-lg">&nbsp;</div>
                            <div className="col-md-12 text-left">
                                <div className="col-md-5 col-md-offset-1">
                                    <h3>EJECUCIÓN</h3>
                                </div >
                                <div className="col-md-4">
                                    <div className="text" dangerouslySetInnerHTML={{__html:getBriefcase(param.id).ejecucion}}></div>
                                </div>
                            </div>
                            <div className="col-md-12">&nbsp;</div>
                        </div>
                    : ""}
                    {getBriefcase(param.id).resultados ? 
                        <div className="row">
                            <hr className="hrGeneral"></hr>
                            <div className="col-md-12 visible-md visible-lg">&nbsp;</div>
                            <div className="col-md-12 visible-md visible-lg">&nbsp;</div>
                            <div className="col-md-12 text-left">
                                <div className="col-md-5 col-md-offset-1">
                                    <h3>RESULTADOS</h3>
                                </div>
                                <div className="col-md-4">
                                    <div className="text" dangerouslySetInnerHTML={{__html:getBriefcase(param.id).resultados}}></div>
                                </div>
                            </div>
                            <div className="col-md-12">&nbsp;</div>
                        </div>
                    : ""}
                    {getBriefcase(param.id).text2 ? 
                        <div className="row">
                            <hr className="hrGeneral visible-md visible-lg"></hr>
                            <div className="col-md-12">&nbsp;</div>
                            <div className="col-md-12">&nbsp;</div>
                            <div className="col-md-12">&nbsp;</div>
                            <div className="col-md-12 text-left">
                                <div className="col-md-8 col-md-offset-2">
                                    <div className="text2" dangerouslySetInnerHTML={{__html:getBriefcase(param.id).text2}}></div>
                                </div>
                            </div>
                        </div>
                    : ""}
                </div>
            </div>
        );
    }
    else
        return (<div></div>);
};
